import i18n from '@/utils/i18n';

const cards = [
    {
        id: 'active_subscribers',
        title: i18n.t('dashboard.card_titles.active_subscribers'),
        tooltipName: i18n.t('dashboard.card_titles.active_subscribers'),
        tooltipText: i18n.t('dashboard.tooltips.active_subscribers'),
        isCurrency: false
    },
    {
        id: 'mrr',
        title: i18n.t('dashboard.card_titles.mrr'),
        tooltipName: i18n.t('dashboard.card_titles.mrr'),
        tooltipText: i18n.t('dashboard.tooltips.mrr'),
        itemValueDecorator: (value, multiplier = 1) => {
            return value * multiplier;
        },
        currentValueDecorator: (value, multiplier = 1) => {
            return value * multiplier;
        },
        comparedValueDecorator: (value, multiplier = 1) => {
            return value * multiplier;
        }
    },
    {
        id: 'gross_live',
        title: i18n.t('dashboard.card_titles.gross_volume'),
        tooltipName: i18n.t('dashboard.card_titles.gross_volume'),
        tooltipText: i18n.t('dashboard.tooltips.gross_volume')
    },
    {
        id: 'new_subscribers',
        title: i18n.t('dashboard.card_titles.new_subscribers'),
        tooltipName: i18n.t('dashboard.card_titles.new_subscribers'),
        tooltipText: i18n.t('dashboard.tooltips.new_subscribers'),
        isCurrency: false
    },
    {
        id: 'new_trials',
        title: i18n.t('dashboard.card_titles.new_trials'),
        tooltipName: i18n.t('dashboard.card_titles.new_trials'),
        tooltipText: i18n.t('dashboard.tooltips.new_trials'),
        isCurrency: false
    },
    {
        id: 'new_starts',
        title: i18n.t('dashboard.card_titles.new_starts'),
        tooltipName: i18n.t('dashboard.card_titles.new_starts'),
        tooltipText: i18n.t('dashboard.tooltips.new_starts'),
        isCurrency: false
    },
    {
        id: 'trials_converted',
        title: i18n.t('dashboard.card_titles.trials_converted'),
        tooltipName: i18n.t('dashboard.card_titles.trials_converted'),
        tooltipText: i18n.t('dashboard.tooltips.trials_converted'),
        isCurrency: false
    },
    {
        id: 'stopped_subscriptions',
        title: i18n.t('dashboard.card_titles.stopped_subscriptions'),
        tooltipName: i18n.t('dashboard.card_titles.stopped_subscriptions'),
        tooltipText: i18n.t('dashboard.tooltips.stopped_subscriptions'),
        isCurrency: false
    },
    {
        id: 'cancelled_subscriptions',
        title: i18n.t('dashboard.card_titles.cancelled_subscriptions'),
        tooltipName: i18n.t('dashboard.card_titles.cancelled_subscriptions'),
        tooltipText: i18n.t('dashboard.tooltips.cancelled_subscriptions'),
        isCurrency: false
    },
    {
        id: 'logged_in_members',
        title: i18n.t('dashboard.card_titles.logged_in_members'),
        tooltipName: i18n.t('dashboard.card_titles.logged_in_members'),
        tooltipText: i18n.t('dashboard.tooltips.logged_in_members'),
        isCurrency: false
    },
    {
        id: 'logged_in_subscribers',
        title: i18n.t('dashboard.card_titles.logged_in_subscribers'),
        tooltipName: i18n.t('dashboard.card_titles.logged_in_subscribers'),
        tooltipText: i18n.t('dashboard.tooltips.logged_in_subscribers'),
        isCurrency: false
    },
    {
        id: 'paywall_hits',
        title: i18n.t('dashboard.card_titles.paywall_hits'),
        tooltipName: i18n.t('dashboard.card_titles.paywall_hits'),
        tooltipText: i18n.t('dashboard.tooltips.paywall_hits'),
        isCurrency: false
    },
]

export default cards
